import React from "react";

import { Auth } from 'aws-amplify';
import { withOAuth } from 'aws-amplify-react';
import Button from 'react-bootstrap/Button';
import '../button/Button.css'

import { useStore } from "../../utils/store";

function LoginButton(oauth) {
    const { state } = useStore();

    let loginButton;
    if (state.logged_in) {
      loginButton = <Button  onClick={() => { Auth.signOut() } } className="btn-red">Logout</Button>;
    } else if (!state.logged_in) {
      loginButton = <Button onClick={() => { oauth.OAuthSignIn() } } className="btn-blue">Login</Button>;
    }

    return <div className="float-right">{loginButton}</div>
  }

  export default withOAuth(LoginButton);
